import fetch from 'cross-fetch';
import { ApiPrefix, statusCheck, json, getCookie } from '../util/icwUtility';
import { actLoginTimedOut } from './loginStateActions';

export const COMPANY_LAB_LIST_FETCH_BEGIN = 'COMPANY_LAB_LIST_FETCH_BEGIN';
function actCompanyLabListFetchBegin() {
  return { type: COMPANY_LAB_LIST_FETCH_BEGIN };
}

export const COMPANY_LAB_LIST_FETCH_SUCCESS = 'COMPANY_LAB_LIST_FETCH_SUCCESS';
export function actCompanyLabListFetchSuccess(data) {
  return { type: COMPANY_LAB_LIST_FETCH_SUCCESS, data };
}

export const COMPANY_LAB_LIST_FETCH_FAIL = 'COMPANY_LAB_LIST_FETCH_FAIL';
function actCompanyLabListFetchFail(reason) {
  return { type: COMPANY_LAB_LIST_FETCH_FAIL, reason };
}

export function actCompanyLabListFetch() {
  return (dispatch) => {
    dispatch(actCompanyLabListFetchBegin());
    return fetch(`${ApiPrefix}/companies/labs`, {
      headers: { Authorization: getCookie('token') },
    })
      .then(statusCheck)
      .then(json)
      .then((data) => dispatch(actCompanyLabListFetchSuccess(data)))
      .catch((err) => {
        if (err.status === 401) {
          dispatch(actLoginTimedOut());
        }

        dispatch(actCompanyLabListFetchFail(typeof err === 'object' ? err.message : err));
      });
  };
}

//
//  ******* Supplier List Related *******
//

export const COMPANY_SUPPLIER_LIST_FETCH_BEGIN = 'COMPANY_SUPPLIER_LIST_FETCH_BEGIN';
function actCompanySupplierListFetchBegin(payload) {
  return { type: COMPANY_SUPPLIER_LIST_FETCH_BEGIN, payload };
}

export const COMPANY_SUPPLIER_LIST_FETCH_SUCCESS = 'COMPANY_SUPPLIER_LIST_FETCH_SUCCESS';
export function actCompanySupplierListFetchSuccess(data) {
  return { type: COMPANY_SUPPLIER_LIST_FETCH_SUCCESS, data };
}

export const COMPANY_SUPPLIER_LIST_FETCH_FAIL = 'COMPANY_SUPPLIER_LIST_FETCH_FAIL';
function actCompanySupplierListFetchFail(reason) {
  return { type: COMPANY_SUPPLIER_LIST_FETCH_FAIL, reason };
}

export function actCompanySupplierListFetch(fetchParams) {
  return (dispatch, getState) => {
    // const { noOfPages } = getState().companies.suppliers;
    const options = !!fetchParams
      ? {
          method: 'POST',
          headers: {
            Authorization: getCookie('token'),
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ ...fetchParams }),
        }
      : {};
    dispatch(actCompanySupplierListFetchBegin(fetchParams));
    return fetch(`${ApiPrefix}/suppliers/list`, {
      headers: { Authorization: getCookie('token') },
      ...options,
    })
      .then(statusCheck)
      .then(json)
      .then((data) => dispatch(actCompanySupplierListFetchSuccess(data)))
      .catch((err) => {
        if (err.status === 401) {
          dispatch(actLoginTimedOut());
        }

        dispatch(actCompanySupplierListFetchFail(typeof err === 'object' ? err.message : err));
      });
  };
}

//
//  ******* Buyer List Related *******
//

export const COMPANY_BUYER_LIST_FETCH_BEGIN = 'COMPANY_BUYER_LIST_FETCH_BEGIN';
function actCompanyBuyerListFetchBegin() {
  return { type: COMPANY_BUYER_LIST_FETCH_BEGIN };
}

export const COMPANY_BUYER_LIST_FETCH_SUCCESS = 'COMPANY_BUYER_LIST_FETCH_SUCCESS';
export function actCompanyBuyerListFetchSuccess(data) {
  return { type: COMPANY_BUYER_LIST_FETCH_SUCCESS, data };
}

export const COMPANY_BUYER_LIST_FETCH_FAIL = 'COMPANY_BUYER_LIST_FETCH_FAIL';
function actCompanyBuyerListFetchFail(reason) {
  return { type: COMPANY_BUYER_LIST_FETCH_FAIL, reason };
}

export function actCompanyBuyerListFetch() {
  return (dispatch) => {
    dispatch(actCompanyBuyerListFetchBegin());
    return fetch(`${ApiPrefix}/buyers`, {
      headers: { Authorization: getCookie('token') },
    })
      .then(statusCheck)
      .then(json)
      .then((data) => dispatch(actCompanyBuyerListFetchSuccess(data)))
      .catch((err) => {
        if (err.status === 401) {
          dispatch(actLoginTimedOut());
        }

        dispatch(actCompanyBuyerListFetchFail(typeof err === 'object' ? err.message : err));
      });
  };
}
